import {FullSafezoneContentDefaultBox} from "./full-safezone-content-default.box";

export const FullSafezoneContentBox = FullSafezoneContentDefaultBox;
